import { apiMapper } from "./ApiMapper";

const AllocationAPI = {
  LIST: (axiosPrivate, clientUuid, pageNumber, pageSize, status) => {
    let url = `${apiMapper.allocation.list}${clientUuid}/?page=${pageNumber}&page_size=${pageSize}`;
    if (status) {
      url += `&status=${status}`;
    }
    return axiosPrivate.get(url);
  },
  DETAIL: (axiosPrivate, id) => {
    return axiosPrivate.get(`${apiMapper.allocation.details}${id}/`);
  },
  UPDATE: (axiosPrivate, id, payload) => {
    return axiosPrivate.put(`${apiMapper.allocation.update}${id}/`, payload);
  },

  DELETE: (axiosPrivate, id, payload) => {
    return axiosPrivate.delete(`${apiMapper.allocation.delete}${id}/`, {
      data: payload
    });
  },

  GET_EST_CON: (axiosPrivate, clientUuid) => {
    return axiosPrivate.get(`${apiMapper.allocation.getEstCon}${clientUuid}/`);
  },
  GET_RES: (axiosPrivate, ConId, EstId) => {
    return axiosPrivate.get(
      `${apiMapper.allocation.getRes}${ConId}/estimation/${EstId}/`
    );
  },
  ADD: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.add, payload);
  },
  ALLOCATION_CHECK: (axiosPrivate, contract_sow_id) => {
    return axiosPrivate.post(
      `${apiMapper.allocation.allocationCheck}${contract_sow_id}/`
    );
  },
  RESOURCE_SEARCH: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.resourceSearch, payload);
  },
  ENHANCED_ADD: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.enhancedAdd, payload);
  },
  ENHANCED_UPDATE: (axiosPrivate, id, payload) => {
    return axiosPrivate.put(
      `${apiMapper.allocation.enhancedUpdate}${id}/`,
      payload
    );
  },
  EMPLOYEE_DISTRIBUTION: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      apiMapper.allocation.employeeDistribution,
      payload
    );
  },
  ALLOCATION_ANALYSIS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.allocationAnalysis, payload);
  },
  GET_PLANNED_HOURS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.getPlannedHours, payload);
  },

  DELETE_SUBMITTED_TIMESHEETS: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      `${apiMapper.allocation.deleteSubmittedTimesheets}`,
      payload
    );
  },

  GET_SPLIT_HOURS: (axiosPrivate, payload) => {
    return axiosPrivate.post(apiMapper.allocation.getSplitHours, payload);
  },

  DELETE_PLACEMENT: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      `${apiMapper.allocation.deletePlacement}`,
      payload
    );
  },
  DELETE_SUBMITTED_TIMESHEETS: (axiosPrivate, payload) => {
    return axiosPrivate.post(
      `${apiMapper.allocation.deleteSubmittedTimesheets}`,
      payload
    );
  }
};

export default AllocationAPI;
